<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { quickCategoriesConfig } from '../Planning/QuickCategories/QuickCategoriesConfig';
    import { AssignmentApi, type AssignmentResponseType } from '../Planning/AssignmentApi';
    import AssignmentSummary from '../Planning/PageScenario/AssignmentSummary.svelte';
    import { AssignmentManager } from '../Planning/PageScenario/AssignmentManager';
    import { QuickCategories } from '../Planning/QuickCategories/QuickCategories';
    import CheckboxLikeFilter from '../../shared/CheckboxLikeFilter.svelte';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import TemplateInner from '../../shared/TemplateInner.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import { type VehicleResponseType } from '../Vehicles/types';
    import { debug, planning } from '../../../stores/store';
    import { ScenarioApi } from '../Planning/ScenarioApi';
    import type { JobResponseType } from '../Jobs/types';
    import { Assignment } from '../Planning/Assignment';
    import { filter } from '../../../stores/filter';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import { api } from '../../../stores/api';
    import { JobApi } from '../Jobs/JobApi';
    import { Job } from '../Jobs/Job';
    import ButtonBack from '../../shared/ButtonBack.svelte';

    export let isOpen: boolean = false;
    export let onClick: (
        assignmentId: number | null,
        assignment: Assignment | null | undefined
    ) => Promise<boolean> = () => {
        return Promise.resolve(true);
    };
    export let selectedScenarioId: number;
    export let vehicles: VehicleResponseType[] = [];
    export let jobId: number | null = null;
    export let inProgressSwitch: boolean = true;
    export let onlyLocked: boolean | null = inProgressSwitch ? false : null;
    export let rejectedAssignments: number[] = [];
    export let excludedAssignments: number[] = [];
    export let calcRoutes: boolean = false;
    export let showCancelButton: boolean = false;

    let onlySuggested: boolean = true;
    let loaded: boolean = false;
    let error: string = '';
    let suggestedAssignmentIds: number[] = [];

    let scenarioManager: AssignmentManager = new AssignmentManager();

    function onSelect(assignmentId: number | null) {
        console.log('ModalSelectRoute', assignmentId);
        if (assignmentId === null) {
            isOpen = false;
            return;
        }
        let assignment = scenarioManager.getAssignmentById(assignmentId);
        if (assignment) {
            console.log('ModalSelectRoute', assignmentId, assignment);
            isOpen = false;
            onClick(assignmentId, assignment).then((close: boolean) => {
                if (close) {
                    console.log('ModalSelectRoute if', close);
                    closeModal();
                } else {
                    console.log('ModalSelectRoute else', close);
                    isOpen = true;
                }
            });
        } else {
            console.error('ModalSelectRoute, Assignment not found', assignmentId);
        }
    }

    onMount(() => {
        (async () => {
            Promise.all([
                AssignmentApi.getWithCountersByScenarioId(
                    get(api),
                    selectedScenarioId,
                    $planning.selectedDay
                ).catch(e => (error = e)),
                jobId ? ScenarioApi.getBestAssignment(get(api), selectedScenarioId, jobId, undefined, calcRoutes) : null,
                jobId ? JobApi.getOne(get(api), jobId) : null,
            ]).then(response => {
                console.log('ModalSelectRoute', jobId);
                let assignments: AssignmentResponseType[] = response[0];
                let estimates: any = [];
                let blocked: any = [];
                if (response[1]) {
                    estimates = response[1]['nearest'] ?? [];
                    blocked = response[1]['blocked'] ?? [];
                }
                let job: Job | null = response[2] ? new Job().set(response[2]) : null;
                if (assignments) {
                    assignments = assignments.filter(a => a.id > 0 && blocked.indexOf(a.id) < 0);
                    assignments.forEach(rass => {
                        let best = estimates
                            ? estimates.filter((e: any) => e.assignment_id == rass.id)[0]
                            : null;
                        if (best) {
                            try {
                                suggestedAssignmentIds.push(rass.id);
                                let distance: number = 0;
                                let eta: number = 0;
                                if (!rass.route_info) {
                                    rass.route_info = { stage: '-' };
                                }
                                if (rass.route_info?.stage == 'completed') {
                                    rass.route_info.stage = '-';
                                    distance = rass.route_info.route?.distance_m || 0;
                                    eta = rass.route_info.route?.eta_with_stops_m || 0;
                                } else if (rass.route_info?.estimate) {
                                    distance = rass.route_info?.estimate?.distance_m || 0;
                                    eta = rass.route_info?.estimate?.eta_with_stops_m || 0;
                                }
                                if (typeof best?.bestfit !== 'undefined' && best?.bestfit!==null) {
                                    rass.route_info.estimate = {
                                        eta_m: eta + best.bestfit.compare.eta_m,
                                        eta_with_stops_m: eta + best.bestfit.compare.eta_m,
                                        distance_m: distance + best.bestfit.compare.distance_m,
                                        eta_diff: eta,
                                        distance_diff: distance,
                                    };
                                }
                            } catch (e) {
                                console.error('Error1', e);
                            }
                        }
                        if (rass.details && job) {
                            rass.details.parcels += job.getParcelCount() || 0;
                            rass.details.total_weight += job.getTotalWeight() || 0;
                        }
                        let assignment = new Assignment(rass);
                        let quickCategories = new QuickCategories(quickCategoriesConfig);
                        assignment.setQuickCategories(quickCategories);
                        scenarioManager.addScenarioSection(assignment);
                    });
                    if (typeof onlyLocked == 'boolean') {
                        scenarioManager.setVisibleLocked(onlyLocked);
                        scenarioManager.setVisibleUnlocked(!onlyLocked);
                    } else {
                        scenarioManager.setVisibleLocked(true);
                        scenarioManager.setVisibleUnlocked(true);
                    }
                    scenarioManager.orderByPriority();
                    if (suggestedAssignmentIds.length) {
                        try {
                            scenarioManager.orderByCallback((a: Assignment, b: Assignment) => {
                                let aSuggested = suggestedAssignmentIds.indexOf(a.getId()) >= 0;
                                let bSuggested = suggestedAssignmentIds.indexOf(b.getId()) >= 0;
                                let getEstimationA = a.getEstimation();
                                let getEstimationB = b.getEstimation();
                                if (aSuggested && bSuggested
                                    && getEstimationA
                                    && getEstimationB
                                    && getEstimationA.distance_m
                                    && getEstimationB.distance_m
                                    && getEstimationB.distance_diff
                                ) {
                                    console.log(
                                        '!!! suggestions',
                                        getEstimationA.distance_diff,
                                        getEstimationB.distance_diff
                                    );
                                    return (
                                        getEstimationA.distance_m -
                                        getEstimationB.distance_diff -
                                        (getEstimationB.distance_m -
                                            getEstimationB.distance_diff)
                                    );
                                } else if (aSuggested) {
                                    return -1;
                                } else if (bSuggested) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            });
                        } catch (e) {
                            console.error('Error2', e);
                        }
                    }
                    scenarioManager.setVehicles(vehicles);
                    scenarioManager = scenarioManager;
                }

                loaded = true;
            });
        })();
    });

    $: {
        if (inProgressSwitch && typeof onlyLocked == 'boolean') {
            scenarioManager.setVisibleLocked(onlyLocked);
            scenarioManager.setVisibleUnlocked(!onlyLocked);
        }
        scenarioManager = scenarioManager;
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            {#if $debug}
                inProgressSwitch: {inProgressSwitch}<br />
                onlyLocked: {onlyLocked}<br />
                onlySuggested: {onlySuggested}<br />
                suggestedAssignmentIds: {JSON.stringify(suggestedAssignmentIds)}<br />
                scenarioManager.showLocked: {scenarioManager?.showLocked}<br />
                scenarioManager.showUnlocked: {scenarioManager?.showUnlocked}<br />
            {/if}
            <div
                style="display: flex; align-items: center; column-gap: 20px; justify-content: space-between; padding:10px 20px 0 20px;"
            >
                <div style="font-size: 18px; font-weight: 500;">
                    {$_('select_vehicle_to_add_jobs')}
                </div>
            </div>
            {#if !loaded}
                <div
                    style="width:100%; height: 100%; display: flex; justify-content: center; align-items: center;"
                >
                    <Spinner />
                </div>
            {:else if error}
                <MessageDanger {error} />
            {:else}
                <div style="display: flex; align-items: center; justify-content: flex-start;">
                    {#if inProgressSwitch && typeof onlyLocked == 'boolean'}
                        <div
                            style="display: flex; flex-direction: row; column-gap: 10px; padding:0 20px 0 20px; justify-content: space-between;"
                        >
                            <div
                                style="display: flex; flex-direction: row; align-items: center; column-gap: 10px;"
                            >
                                <CheckboxLikeFilter
                                    bind:checked={onlyLocked}
                                    label={$_('routes in progress')}
                                />
                            </div>
                        </div>
                    {/if}
                    {#if suggestedAssignmentIds.length > 0 && calcRoutes}
                        <div
                            style="display: flex; flex-direction: row; column-gap: 10px; padding:0 20px 0 20px; justify-content: space-between;"
                        >
                            <div
                                style="display: flex; flex-direction: row; align-items: center; column-gap: 10px; text-transform: lowercase"
                            >
                                <CheckboxLikeFilter
                                    bind:checked={onlySuggested}
                                    label={$_('suggested_assignments_only')}
                                />
                            </div>
                        </div>
                    {/if}
                </div>

                <div class="scrollable-list">
                    <!--                    <div style="margin: 20px 0 0 0; overflow-x: hidden; flex:1;">-->
                    <div class="section-list" class:simpleView={false}>
                        {#each scenarioManager.getScenarioSections(false) as assignment, index}
                            {#if (!onlySuggested || suggestedAssignmentIds.length === 0 || suggestedAssignmentIds.indexOf(assignment.getId()) >= 0) && excludedAssignments.indexOf(assignment.getId()) < 0}
                                <div>
                                    <AssignmentSummary
                                        bind:assignment
                                        rejected={rejectedAssignments.indexOf(assignment.getId()) >=
                                            0}
                                        {vehicles}
                                        showHeader={index === 0}
                                        showActions={false}
                                        showVehicleIcon={true}
                                        showSelectCheckbox={false}
                                        showRouteParamsAlways={true}
                                        filterHideMethod={'hide'}
                                        onClickHeader={() => {
                                            console.log('click header', assignment.getId());
                                            onSelect(assignment.getId());
                                            /*
                                                        leaveMapObjects = true;
                                                        navigate(`/planning/${assignment.getId()}`)
                                                        */
                                        }}
                                    />
                                </div>
                            {/if}
                        {:else}
                            <TemplateInner>
                                <MessageNotFound text={$_('Not found any jobs for this day')} />
                            </TemplateInner>
                        {/each}
                    </div>
                </div>
            {/if}
            {#if showCancelButton}
                <div class="actions">
                    <ButtonBack text={$_('Cancel')} showIcon={false} on:click={closeModal} />
                </div>
            {/if}
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 850px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        pointer-events: auto;
        font-size: 14px;
        padding: 20px 20px 30px 20px;
        height: 560px;
        row-gap: 20px;
        /*background: silver;*/
    }

    .scrollable-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 450px;
        background-color: white;
        padding: 20px;
        border-radius: 3px;
        flex: 1 1 auto;
        /*overflow: hidden;*/
    }
    .actions {
        display: flex;
        justify-content: center;
        padding-top: 20px;
    }
</style>
